import { formatMoney } from "@/lib/api";

export const toB64 = (file) => new Promise((res, rej) => {
  const r = new FileReader();
  r.onload = () => res(r.result);
  r.onerror = rej;
  r.readAsDataURL(file);
});

export const fotoUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const Q = ({ v, className = "" }) => <span className={`tabular-nums ${className}`}>{formatMoney(v || 0)}</span>;

export const Pill = ({ tone = "zinc", children, testid }) => {
  const t = {
    green: "bg-emerald-100 text-emerald-800 border-emerald-300",
    amber: "bg-amber-100 text-amber-900 border-amber-300",
    purple: "bg-violet-100 text-violet-800 border-violet-300",
    zinc: "bg-zinc-100 text-zinc-700 border-zinc-300",
    red: "bg-red-100 text-red-800 border-red-300",
  }[tone];
  return <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-bold ${t}`} data-testid={testid}>{children}</span>;
};

export const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
export const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
export const fechaLarga = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return `${DIAS[new Date(y, m - 1, d).getDay()]}, ${String(d).padStart(2, "0")} de ${MESES[m - 1]} de ${y}`;
};
export const hoyGT = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Guatemala" });
